import { Fetch } from '../helpers/fetchWrapper';

const chatService = {
  _url: process.env.REACT_APP_CHAT_API_URL,
  _main_url: process.env.REACT_APP_AUTH_API_URL,

  async createChat(payload) {
    return await Fetch.post(`${this._url}`, payload, false, true);
  },
  async generateTitle(payload) {
    return await Fetch.post(`${this._main_url}/title/generate`, payload);
  },
};

export default chatService;
